import { Translation, useSafetyTranslation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import type { TCockpitAttentionGrouping } from '../../../../model/types'
import { CockpitGrouping } from '../../../components/cockpitGrouping'
import { useAttentionStatusesText } from '../../hooks/useAttentionStatusesText'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.attentionStatuses.grouping

interface IAttentionStatusesGroupingProps {
  grouping: TCockpitAttentionGrouping
  options: TCockpitAttentionGrouping[]
  scopeName?: string | null
  onChange: (grouping: TCockpitAttentionGrouping) => void
}

export const AttentionStatusesGrouping = ({
  grouping,
  options,
  scopeName,
  onChange,
}: IAttentionStatusesGroupingProps) => {
  const t = useSafetyTranslation()
  const text = useAttentionStatusesText()
  return (
    <CockpitGrouping
      value={grouping}
      options={options.map((option) => ({
        value: option,
        label: <Translation text={KEYS[option]} span />,
      }))}
      label={<Translation span text={KEYS.label} />}
      ariaLabel={t(KEYS.ariaLabel).replaceAll('{grouping}', t(KEYS[grouping]))}
      optionsAriaLabel={t(KEYS.label)}
      heading={
        scopeName ? <Translation span {...text.phrase.groupingApplyTo(scopeName)} /> : undefined
      }
      onChange={onChange}
    />
  )
}

AttentionStatusesGrouping.displayName = 'AttentionStatusesGrouping'
